<script setup lang="ts" generic="T extends BaseProps<any>">
import type { defineActions, defineState } from "../common";
import { Buttons } from "../icons";
import type { BaseProps } from "../props";

const props = defineProps<{
    state: ReturnType<typeof defineState>;
    param: T;
    actions: ReturnType<typeof defineActions>;
    showUpdate?: boolean;
}>();
</script>

<template>
    <div v-if="props.param.embedMode !== 'embed' && props.param.mode === 'update'" class="flex flex-row gap-1">
        <template v-if="!props.state.editMode">
            <Buttons.BtnUpdate v-if="props.showUpdate === true" @click="actions.onUpdate" />
            <Buttons.BtnDelete v-if="props.state.deletable" @click="props.actions.onDelete" />
        </template>
        <template v-else>
            <Buttons.BtnSubmit v-if="props.state.hasValue" @click="props.actions.onSubmit" />
            <Buttons.BtnCancel @click="props.actions.onCancel" />
        </template>
    </div>
</template>
